var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Article',{attrs:{"page":_vm.page}})
}
var staticRenderFns = []

export { render, staticRenderFns }